import {IController, IModule, IOnChangesObject} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";

const css = require('./logo.scss');

export class LogoKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmLogo', {
                controller: LogoKontroller.forInjisering(),
                template: require('./logo.html'),
                bindings: {
                    visSpLogo:'<'
                },
            });
    }

    static forInjisering() {
        return [
            LogoKontroller
        ]
    }

    constructor() {
    }

    visSpLogo:boolean; //satt via bindings
}
